import React, { useEffect, useId, useState } from "react";
import { Link } from "react-router-dom";
import AcademicLevelService from "../../service/academicLevelService";

const AcademicStageMenu = ({ stage, open, onOpen, onNavigate }) => {
  const id = useId();
  const [levels, setLevels] = useState(null);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    if (!open || levels !== null) return;
    const controller = new AbortController();
    setError(false);
    AcademicLevelService.getAcademicLevelsByStage(stage.id, { signal: controller.signal }).then((result) => {
      if (controller.signal.aborted) return;
      if (result.success && Array.isArray(result.data)) setLevels(result.data);
      else setError(true);
    });
    return () => controller.abort();
  }, [open, stage.id, levels, attempt]);

  return (
    <li className="education-stage" onMouseEnter={onOpen}>
      <button type="button" className="education-stage-toggle" aria-expanded={open} aria-controls={id} onClick={onOpen} onFocus={onOpen}>
        {stage.name} <i className="fal fa-angle-right" aria-hidden="true" />
      </button>
      <ul id={id} className="education-stage-levels" hidden={!open}>
        {error ? <li><p role="alert">Impossible de charger les niveaux.</p><button type="button" onClick={() => setAttempt(value => value + 1)}>Réessayer</button></li>
          : levels === null ? <li role="status">Chargement…</li>
          : levels.length === 0 ? <li>Aucun niveau disponible</li>
          : levels.map(level => <li key={level.id}><Link to={`/course-1?levelId=${encodeURIComponent(level.id)}`} onClick={onNavigate}>{level.name}</Link></li>)}
      </ul>
    </li>
  );
};

export default AcademicStageMenu;
